import React, { useState, useEffect } from 'react'
import { FetchMobilePrefillDataAPi } from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import NoData from '../../../../../images/nodata.png'
import Popup from '../../../../presentationals/Popup/Popup.component'

export default function FetchPrefillDataPopup({ userdata, admin, hnadlePrefetchPopupOpenPopup }) {
    const [loader, setLoader] = useState(false);
    const [popup,setpopup] =useState({show:false,popupStatus:""})
    const [prefillData, setPrefillData] = useState({});

    const closePopup =()=>{setpopup({show:false,popupStatus:""})}
    const removePopup=()=>{setTimeout(()=>{closePopup()},5000)}

    useEffect(() => {
        FetchData();
    }, []);

    const FetchData = () => {
        setLoader(true);
        FetchMobilePrefillDataAPi(userdata?.userId, (callback) => {
            setLoader(false);
            if (callback?.result_code == 101) {
                setPrefillData(callback?.result ?? {});
            } else if(callback?.result_code == 102) {
                setpopup({show:true,popupStatus:"Record Not found"})
                removePopup()
                setPrefillData({});
            } else if(callback?.result_code == 103) {
                setpopup({show:true,popupStatus:"Name not found against mobile no"})
                removePopup()
                setPrefillData({});
            } else {
                setpopup({show:true,popupStatus:"Error: Please Try again later!"})
                removePopup()
                setPrefillData({});
            }
        });
    };

    const hasData = prefillData && Object.keys(prefillData).length > 0;

    return (
        <>
        {
            popup?.show ? 

            <Popup popupStatus={popup?.popupStatus} closePopup={closePopup}/> 
            :""
        }
            <style>{`
                .prefill-popup-backdrop {
                    position: fixed;
                    inset: 0;
                    background: rgba(15, 23, 42, 0.4);
                    backdrop-filter: blur(8px);
                    z-index: 1040;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .prefill-popup-card {
                    background: rgba(255, 255, 255, 0.95);
                    backdrop-filter: blur(12px);
                    border-radius: 16px;
                    border: 1px solid rgba(255, 255, 255, 0.6);
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
                    padding: 24px;
                    max-width: 700px;
                    width: 90%;
                    max-height: 85vh;
                    overflow-y: auto;
                    position: relative;
                    color: #1e293b;
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                }
                .prefill-close-btn {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    border: none;
                    background: #f1f5f9;
                    color: #64748b;
                    font-size: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }
                .prefill-close-btn:hover {
                    background: #e2e8f0;
                    color: #1e293b;
                    transform: rotate(90deg);
                }
                .prefill-title {
                    font-size: 20px;
                    font-weight: 750;
                    text-align: left;
                    margin-bottom: 20px;
                    padding-bottom: 12px;
                    border-bottom: 2px solid #f1f5f9;
                    background: linear-gradient(135deg, #1e293b, #475569);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .prefill-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 14px;
                    margin-bottom: 24px;
                    text-align: left;
                }
                @media (max-width: 600px) {
                    .prefill-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }
                }
                @media (max-width: 440px) {
                    .prefill-grid {
                        grid-template-columns: 1fr;
                    }
                }
                .prefill-item {
                    background: #f8fafc;
                    border: 1px solid #f1f5f9;
                    border-radius: 10px;
                    padding: 12px 14px;
                }
                .prefill-label {
                    font-size: 11px;
                    font-weight: 600;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    margin-bottom: 4px;
                }
                .prefill-value {
                    font-size: 14px;
                    font-weight: 600;
                    color: #0f172a;
                    word-break: break-all;
                }
                .prefill-score-badge {
                    background: #e2fbf0;
                    color: #15803d;
                    padding: 2px 8px;
                    border-radius: 12px;
                    font-weight: 700;
                    font-size: 13px;
                    display: inline-block;
                }
                .prefill-address-section {
                    text-align: left;
                }
                .prefill-address-title {
                    font-size: 15px;
                    font-weight: 700;
                    color: #334155;
                    margin-bottom: 12px;
                }
                .prefill-address-list {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
                .prefill-address-card {
                    background: #ffffff;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 12px 16px;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: flex-start;
                }
                .prefill-address-card:hover {
                    border-color: #3b82f6;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                    transform: translateY(-1px);
                }
                .prefill-address-icon {
                    font-size: 18px;
                    color: #3b82f6;
                    margin-right: 12px;
                    margin-top: 2px;
                }
                .prefill-phone-section {
                    text-align: left;
                    margin-top: 20px;
                }
                .prefill-phone-title {
                    font-size: 15px;
                    font-weight: 700;
                    color: #334155;
                    margin-bottom: 12px;
                }
                .prefill-phone-list {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }
                .prefill-phone-card {
                    background: #ffffff;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 12px 16px;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: center;
                }
                .prefill-phone-card:hover {
                    border-color: #10b981;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
                    transform: translateY(-1px);
                }
                .prefill-phone-icon {
                    font-size: 16px;
                    color: #10b981;
                    margin-right: 12px;
                    flex-shrink: 0;
                }
                .prefill-phone-text {
                    font-size: 13.5px;
                    color: #334155;
                }
                .prefill-address-text {
                    font-size: 13.5px;
                    line-height: 1.5;
                    color: #334155;
                }
                .prefill-no-data {
                    text-align: center;
                    padding: 40px 20px;
                }
                .prefill-no-data-img {
                    max-width: 130px;
                    margin-bottom: 16px;
                    opacity: 0.8;
                }
                .prefill-no-data-text {
                    font-size: 15px;
                    font-weight: 600;
                    color: #64748b;
                }
            `}</style>

            

            <div className="prefill-popup-backdrop" onClick={() => hnadlePrefetchPopupOpenPopup(false)}>
                <div className="prefill-popup-card" onClick={(e) => e.stopPropagation()}>
                    <button className="prefill-close-btn" onClick={() => hnadlePrefetchPopupOpenPopup(false)}>
                        &times;
                    </button>
                    <div className="prefill-title">Prefilled Customer Data</div>
{loader && <Loader />}
                    {hasData ? (
                        <>
                            <div className="prefill-grid">
                                <div className="prefill-item">
                                    <div className="prefill-label">Full Name</div>
                                    <div className="prefill-value">{prefillData.name || 'N/A'}</div>
                                </div>
                                <div className="prefill-item">
                                    <div className="prefill-label">PAN Number</div>
                                    <div className="prefill-value">{prefillData.pan || 'N/A'}</div>
                                </div>
                                <div className="prefill-item">
                                    <div className="prefill-label">Date of Birth</div>
                                    <div className="prefill-value">{prefillData.dob || 'N/A'}</div>
                                </div>
                                <div className="prefill-item">
                                    <div className="prefill-label">Gender</div>
                                    <div className="prefill-value">{prefillData.gender || 'N/A'}</div>
                                </div>
                                <div className="prefill-item">
                                    <div className="prefill-label">Age</div>
                                    <div className="prefill-value">{prefillData.age || 'N/A'}</div>
                                </div>
                                <div className="prefill-item">
                                    <div className="prefill-label">Email Address</div>
                                    <div className="prefill-value">{prefillData.email || 'N/A'}</div>
                                </div>
                                <div className="prefill-item" style={{ gridColumn: 'span 3' }}>
                                    <div className="prefill-label">Credit Score</div>
                                    <div className="prefill-value">
                                        <span className="prefill-score-badge">
                                            <i className="fa fa-tachometer" style={{ marginRight: '6px' }}></i>
                                            {prefillData.score || 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {prefillData?.["alternate_mobile_numbers"] && prefillData?.["alternate_mobile_numbers"]?.length > 0 ? (
                                <div className="prefill-phone-section">
                                    <div className="prefill-phone-title">Phone Numbers Found ({prefillData["alternate_mobile_numbers"].length})</div>
                                    <div className="prefill-phone-list">
                                        {prefillData?.["alternate_mobile_numbers"]?.map((ph, index) => {
                                            const phoneNumber = ph;
                                            const reportedDate =  '';
                                            const phoneType = '';
                                            return (
                                                <div className="prefill-phone-card" key={index}>
                                                    <div className="prefill-phone-icon">
                                                        <i className="fa fa-phone"></i>
                                                    </div>
                                                    <div className="prefill-phone-text">
                                                        <span style={{ fontWeight: '700', color: '#1e293b' }}>
                                                            {typeof phoneNumber === 'string' || typeof phoneNumber === 'number' ? phoneNumber : `Phone #${index + 1}`}
                                                        </span>
                                                        {phoneType && (
                                                            <span style={{ marginLeft: '8px', fontSize: '11px', background: '#f0fdf4', color: '#15803d', padding: '1px 7px', borderRadius: '10px', fontWeight: '600' }}>
                                                                {phoneType}
                                                            </span>
                                                        )}
                                                        {reportedDate && (
                                                            <span style={{ marginLeft: '8px', fontSize: '11px', color: '#94a3b8' }}>
                                                                Reported: {reportedDate}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ) : null}

                            {prefillData.address && prefillData.address.length > 0 ? (
                                <div className="prefill-address-section" style={{marginTop:'10px'}}>
                                    <div className="prefill-address-title">Addresses Found ({prefillData.address.length})</div>
                                    <div className="prefill-address-list">
                                        {prefillData.address.map((addr, index) => {
                                            const fullAddress = [
                                                addr.first_line_of_address,
                                                addr.second_line_of_address,
                                                addr.third_line_of_address,
                                                addr.city,
                                                addr.state,
                                                addr.postal_code,
                                                addr.country_code
                                            ].filter(val => val && val.trim() !== '').join(', ');

                                            return (
                                                <div className="prefill-address-card" key={index}>
                                                    <div className="prefill-address-icon">
                                                        <i className="fa fa-map-marker"></i>
                                                    </div>
                                                    <div className="prefill-address-text">
                                                        <div style={{ fontWeight: '700', color: '#1e293b' }}>
                                                            Address #{index + 1} {addr.reported_date && `(Reported: ${addr.reported_date})`}
                                                        </div>
                                                        <div style={{ marginTop: '4px', color: '#475569' }}>{fullAddress}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ) : (
                                <div style={{ textAlign: 'left', color: '#64748b', fontSize: '13px' }}>
                                    No addresses found in prefill records.
                                </div>
                            )}
                         
                            
                        </>
                    ) : (
                        !loader && (
                            <div className="prefill-no-data">
                                <img className="prefill-no-data-img" src={NoData} alt="No Data" />
                                <div className="prefill-no-data-text">No prefilled data found for this applicant.</div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </>
    );
}
